<template>
  <div>
    <div class="post-block width-66 width-sm-100 mx-auto">
      <!-- search box -->
      <vs-card class="border-top" v-if="checkBlogViewPermission()">
        <vs-row vs-type="flex" vs-justify="space-between">
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="11"
          >
            <vs-input
              class="w-full"
              v-model="searchData"
              icon-after
              placeholder="Search..."
              @keyup.native.enter="searchBlog"
            />
          </vs-col>
          <vs-col
            vs-type="flex"
            vs-justify="center"
            vs-align="center"
            vs-w="0.9"
          >
            <vs-button
              color="primary"
              @click="searchBlog"
              class="btn-drop"
              type="filled"
              icon-pack="feather"
              icon="icon-search"
            ></vs-button>
          </vs-col>
        </vs-row>
      </vs-card>
      <!-- post your feedback -->
      <vs-card v-if="checkBlogCreatePermission()" class="border-top">
        <div class="flex flex-wrap justify-between" slot="header">
          <div class="flex">
            <img
              v-if="user.picture != null || user.picture != ''"
              :src="user.picture"
              alt="user-img"
              width="40"
              height="40"
              class="rounded-full shadow-md cursor-pointer block"
            />
            <img
              v-else
              src="@/assets/images/pages/user-circle-solid.svg"
              alt="user-img"
              width="40"
              height="40"
              class="rounded-full shadow-md cursor-pointer block"
            />
            <div class="ml-4">
              <h5>{{ customerName }} <span v-if="user.last_name!=null">{{user.last_name}}</span></h5>
              <p v-if="customerType == 1">Admin</p>
              <p v-if="customerType == 0">Staff</p>
            </div>
          </div>

          <!-- <div class="dropdown-button-container">
            <vs-dropdown>
              <vs-button
                color="dark"
                size="large"
                class="btn-drop"
                type="flat"
                icon="launch"
              ></vs-button>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  :disabled="blogData.blog == '' && blogData.title == ''"
                  @click="submit"
                >
                  Post
                </vs-dropdown-item>
                <vs-dropdown-item
                  :disabled="blogData.blog == '' && blogData.title == ''"
                  @click="submitWithShare(shared)"
                >
                  Post & Share
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div> -->
          <div
            style="padding: 7px; float: right;"
          >
            <vs-button
              class="custom-btn1"
              type="border"
              style="border-radius: 5px 0px 0px 5px; padding: 7px; font-size: 12px; font-weight: 600;"
              :disabled="showPostButton"
              @click="submit(false)"
              >Post</vs-button
            >
            <vs-button
              class="custom-btn1"
              type="border"
              style="border-radius: 0px 5px 5px 0px; padding: 7px; font-size: 12px; font-weight: 600;"
              :disabled="showPostButton"
              @click="submitWithShare(shared)"
              v-if="checkBlogSharePermission()"
              >Post & Share</vs-button
            >
          </div>
        </div>

        <vs-textarea
          class="mt-5"
          v-model="blogData.title"
          placeholder="Title"
        />
        <editor
          v-model="blogData.blog"
          :api-key="tinyMceApi"
          :init="initializeTinyMce"
        />
      </vs-card>

      <!-- news feed blogs -->
      <span v-if="checkBlogViewPermission()">
      <span :key="index1" v-for="(fetchBlog, index1) in fetchBlogData">
        <vs-card class="border-top">
          <!-- header of news feed blog -->
          <div class="flex justify-between" slot="header">
            <div class="flex">
              <img
                v-if="fetchBlog.user.picture!=null || fetchBlog.user.picture!=''"
                :src="fetchBlog.user.picture"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
              <img v-else
                src="@/assets/images/pages/user-circle-solid.svg"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
              <div class="ml-4">
                <h5>
                  {{ fetchBlog.user.first_name }}&nbsp;{{
                    fetchBlog.user.last_name
                  }}
                </h5>
                <div class="info_block">
                  <p>{{ fetchBlog.last_updated_time }}</p>
                </div>
              </div>
            </div>
            <div class="dropdown-button-container" v-if="user.id == fetchBlog.user.id">
              <vs-dropdown>
                <vs-button
                  color="dark"
                  size="large"
                  class="btn-drop"
                  type="flat"
                  icon="more_vert"
                ></vs-button>
                <vs-dropdown-menu >
                  <vs-dropdown-item v-if="checkBlogEditPermission()" @click="editPopup(fetchBlog.id)">
                    Edit
                  </vs-dropdown-item>
                  <vs-dropdown-item v-if="checkBlogDeletePermission()" @click="blogDeletePopUp(fetchBlog.id)">
                    Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>

          <!-- feed saying's -->
          <div @click="openWithDetails(fetchBlog.id)" class="blog-content break-all my-4 cursor-pointer">
            <h6>{{ fetchBlog.title }}</h6>
          </div>
          <div class="blog-content my-4">
            <p v-html="fetchBlog.blog"></p>
          </div>

          <!-- number of likes and number of comments -->
          <div class="like-section ml-3 py-4 divider">
            <div class="w-1/2" v-if="fetchBlog.emoticons.length > 0">
            <div  class="flex items-center">
              <div
                class="emoticons-holder"
                :key="index10"
                v-for="(emo, index10) in fetchBlog.emoticons"
              >
              <!-- {{emo}} -->
                <div class="flex flex-wrap">
                  <span v-if="customerType == 1">
                    <span class="mr-2" >
                      <img  :src="emo.emo_file" />
                    </span>
                  </span>

                  <span v-if="customerType == 0">
                    <span class="mr-2">
                      <img :src="emo.emo_file" />
                    </span>
                  </span>                    
                </div>
                
                <div class="emoticons-list">
                  <!-- {{emo}} -->
                  <b>{{emo.name}}</b>
                  <!-- <p>{{emo.blog_users_id}}</p> -->
                </div>
              </div>
                {{ fetchBlog.emoticons.length }}
                </div>
                
              </div>
         
            <div class="flex items-center justify-end w-1/2">
              <p>Comments</p>
              <p v-if="fetchBlog.comments_count > 0" class="ml-2">
                {{ fetchBlog.comments_count }}
              </p>
            </div>
          </div>

          <!-- like, comment share section -->
          <div class="flex justify-between py-4 mb-4 divider">
            <div class="like-reaction">
              <div v-if="fetchBlog.emoticons.length > 0">
              <span v-if="customerType == 1 || customerType == 0">
                <span v-if="!fetchBlog.emoticons.find(u => u.blog_users_id == user.id)">
                      <strong  class="ml-2">Like</strong>
                </span>

                <span v-else>
                  <div
                  :key="index10"
                  v-for="(emo, index10) in fetchBlog.emoticons"
                >
                
                <span class="mr-2" v-if="user.id == emo.blog_users_id">
                    <img @click="emojiDelete(fetchBlog.id)" :src="emo.emo_file" />
                </span>
                
                </div>
                </span>
               </span>
                         
              </div>
               <div v-if="fetchBlog.emoticons.length == 0">
                 <span v-if="customerType == 1 || customerType == 0">
                            <strong class="ml-2">Like</strong>
                          </span>
                      </div>
           
              <div class="emoji-section">
                <div :key="index4" v-for="(emoticon, index4) in emoticonsList">
                  <img
                    @click="emojiSelected(fetchBlog.id, emoticon.id)"
                    :src="emoticon.emo_file"
                  />
                </div>
              </div>
            </div>

            <div
              @click="toggleComment(fetchBlog)"
              class="flex items-center cursor-pointer"
            >
              <feather-icon icon="MessageSquareIcon" />
              <p class="ml-2">Comment</p>
            </div>

            <div v-if="user.id == fetchBlog.user.id && checkBlogSharePermission()"
              @click="openShareModal(fetchBlog.id)"
              class="flex items-center cursor-pointer"
            >
              <!-- <feather-icon icon="Share2Icon" /> -->
              <span class="material-icons share-rotate">reply</span>
              <p class="ml-2">Share</p>
            </div>
          </div>

          <!-- comments blog -->
          <div
            :style="{ display: 'none' }"
            :ref="fetchBlog.id"
            v-if="
              fetchBlog.comments.length != 0 || fetchBlog.comments.length == 0
            "
          >
            <h5>Comments</h5>

            <!-- commented blog -->
            <div
              class="commented-section my-4"
              :key="index2"
              v-for="(comment, index2) in fetchBlog.comments"
            >
              <div v-if="comment.parent_id == 0">
                <div class="flex">
                  <img v-if="comment.persons.picture != null && comment.persons.picture!= ''"
                    :src="comment.persons.picture"
                    alt="user-img"
                    width="40"
                    height="40"
                    class="rounded-full shadow-md cursor-pointer block"
                  />
                  <img v-else
                    src="@/assets/images/pages/user-circle-solid.svg"
                    alt="user-img"
                    width="40"
                    height="40"
                    class="rounded-full shadow-md cursor-pointer block"
                  />
                  <div class="feedback-block w-auto ml-4">
                    <div class="flex justify-between items-center mb-4">
                      <!-- {{comment}} -->
                      <h6>
                        {{ comment.persons.first_name }}&nbsp;{{
                          comment.persons.last_name
                        }}
                      </h6>
                      <p class="ml-5">{{ comment.last_updated_time }}</p>
                    </div>
                    <p>{{ comment.comments }}</p>

                    <div
                      class="commented-emoji"
                      v-if="comment.emoticons.length > 0"
                    >
                      <div
                        :key="index9"
                        v-for="(emo, index9) in comment.emoticons"
                      >
                        <span v-if="customerType == 0">
                          <img
                            class="emoji"
                            :src="emo.emo_file"
                          />
                          
                          <!-- <p class="ml-2">{{emo.name}}</p> -->
                        </span>
                        <span v-if="customerType == 1">
                          <img
                            class="emoji"
                            :src="emo.emo_file"
                          />
                         
                          <!-- <p class="ml-2">{{emo.name}}</p> -->
                        </span>
                      </div>
                      <span class="ml-2">{{
                            comment.emoticons.length
                          }}</span>
                    </div>
                  </div>
                </div>

                <div class="flex items-center">
                  <div class="mr-4">
                    <p
                      @click="showCommentById(fetchBlog.id, comment)"
                      class="reply-para cursor-pointer"
                    >
                      <strong
                        ><span v-if="comment.children.length != 0">{{
                          comment.children.length
                        }}</span>
                        Reply</strong
                      >
                    </p>
                  </div>

                  <div class="mr-4">
                    <div class="like-reaction">
                      <div v-if="comment.emoticons.length > 0">
                        
                  <span v-if="customerType == 1 || customerType == 0">
                <span v-if="!comment.emoticons.find(u => u.comment_users_id == user.id)">
                      <strong  class="ml-2">Like</strong>
                </span>

                <span v-else>
                  <div
                          :key="index9"
                          v-for="(emo, index9) in comment.emoticons"
                        >
                        <span class="mr-2" v-if="user.id == emo.comment_users_id">
                    <img @click="commentsEmojiDelete(fetchBlog.id,comment.id)" :src="emo.emo_file" />
                </span>
                          
                        </div>
                </span>
               </span>

                      </div>
                      <div v-if="comment.emoticons.length == 0">
                        <span v-if="customerType == 1 || customerType == 0">
                        <!-- <feather-icon icon="ThumbsUpIcon" /> -->
                        <strong class="ml-2">Like</strong>
                        </span>
                      </div>
                      <div class="emoji-section">
                        <div
                          :key="index6"
                          v-for="(emoticon, index6) in emoticonsList"
                        >
                          <img
                            @click="
                              commentsEmojiSelected(
                                fetchBlog.id,
                                emoticon.id,
                                comment.id
                              )
                            "
                            :src="emoticon.emo_file"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <div class="dropdown-button-container" v-if="user.id == comment.persons.id">
                      <vs-dropdown>
                        <vs-button
                          color="dark"
                          size="large"
                          class="btn-drop"
                          type="flat"
                          icon="more_vert"
                        ></vs-button>
                        <vs-dropdown-menu>
                          <vs-dropdown-item
                            @click="commentEditView(fetchBlog.id, comment.id)"
                          >
                            Edit
                          </vs-dropdown-item>
                          <vs-dropdown-item
                            @click="deleteComment(fetchBlog.id, comment.id)"
                          >
                            Delete
                          </vs-dropdown-item>
                        </vs-dropdown-menu>
                      </vs-dropdown>
                    </div>
                  </div>
                </div>

                <!-- reply to a specific comment section -->
                <div :style="{ display: 'none' }" :ref="comment.id">
                  <div class="replied-section my-4">
                  <div
                    v-if="comment.children.length != 0"
                  >
                    <div
                      class="my-4"
                      :key="index3"
                      v-for="(reply, index3) in comment.children"
                    >
                      <div class="flex">
                        <img v-if="reply.persons.picture != null || reply.persons.picture != ''"
                          :src="reply.persons.picture"
                          alt="user-img"
                          width="40"
                          height="40"
                          class="rounded-full shadow-md cursor-pointer block"
                        />
                        <img v-else
                          src="@/assets/images/pages/user-circle-solid.svg"
                          alt="user-img"
                          width="40"
                          height="40"
                          class="rounded-full shadow-md cursor-pointer block"
                        />
                        <div class="feedback-block w-auto ml-4">
                          <div class="flex justify-between items-center mb-4">
                          
                            <h6>{{reply.persons.first_name}}&nbsp;{{reply.persons.last_name}}</h6>
                            <p>{{ reply.last_updated_time }}</p>
                          </div>
                          <p>{{ reply.comments }}</p>

                          <div
                            class="commented-emoji"
                            v-if="reply.emoticons.length > 0"
                          >
                            <div
                              :key="index8"
                              v-for="(emo, index8) in reply.emoticons"
                            >
                            
                              <span v-if="customerType == 0">
                                <img
                                  class="emoji"
                                 
                                  :src="emo.emo_file"
                                />
                                
                                <!-- <p class="ml-2">{{emo.name}}</p> -->
                              </span>
                              <span v-if="customerType == 1">
                                <img
                                  class="emoji"
                                 
                                  :src="emo.emo_file"
                                />
                               
                                <!-- <p class="ml-2">{{emo.name}}</p> -->
                              </span>
                            </div>
                            <span class="ml-2">{{
                                  reply.emoticons.length
                                }}</span>
                          </div>
                        </div>
                      </div>

                      <!-- reply to a specific comment section -->

                      <div class="flex items-center">
                        <div class="reply-para mr-4">
                          <div class="like-reaction">
                            <div v-if="reply.emoticons.length > 0">
                           
                           <span v-if="customerType == 1 || customerType == 0">
                            <span v-if="!reply.emoticons.find(u => u.comment_users_id == user.id)">
                                  <strong  class="ml-2">Like</strong>
                            </span>

                            <span v-else>
                              <div
                                            :key="index8"
                                            v-for="(emo, index8) in reply.emoticons"
                                          >
                              
                              <span class="mr-2" v-if="user.id == emo.comment_users_id">
                              <img @click="replyEmojiDelete(fetchBlog.id,reply.parent_id,reply.id)" :src="emo.emo_file" />
                          </span>
                            
                              </div>
                            </span>
                          </span>
                            </div>
                            <div v-if="reply.emoticons.length == 0">
                              <span v-if="customerType == 1 || customerType == 0">
                              <!-- <feather-icon icon="ThumbsUpIcon" /> -->
                              <strong class="ml-2">Like</strong>
                              </span>
                            </div>

                            <div class="emoji-section">
                              <div
                                :key="index4"
                                v-for="(emoticon, index4) in emoticonsList"
                              >
                                <img
                                  @click="
                                    replyEmojiSelected(
                                      fetchBlog.id,
                                      emoticon.id,
                                      reply.id,
                                      reply.parent_id
                                    )
                                  "
                                  :src="emoticon.emo_file"
                                />
                              </div>
                            </div>
                          </div>
                        </div>

                        <div>
                          <div class="dropdown-button-container" v-if="user.id == reply.persons.id">
                            <vs-dropdown>
                              <vs-button
                                color="dark"
                                size="large"
                                class="btn-drop"
                                type="flat"
                                icon="more_vert"
                              ></vs-button>
                              <vs-dropdown-menu>
                                <vs-dropdown-item
                                  @click="
                                    replyEditView(
                                      fetchBlog.id,
                                      reply.id,
                                      index2
                                    )
                                  "
                                >
                                  Edit
                                </vs-dropdown-item>
                                <vs-dropdown-item
                                  @click="deleteReply(fetchBlog.id, reply.id, reply.parent_id)"
                                >
                                  Delete
                                </vs-dropdown-item>
                              </vs-dropdown-menu>
                            </vs-dropdown>
                          </div>
                        </div>
                      </div>
                    </div>
                    </div>

                    <!-- reply textarea -->
                    <div
                      class="flex my-4"
                      v-if="
                        editReplyBoxShow === false || editCommentId === comment.id
                      "
                    >
                      <img v-if="user.picture != null || user.picture != ''"
                        :src="user.picture"
                        alt="user-img"
                        width="40"
                        height="40"
                        class="rounded-full shadow-md cursor-pointer block"
                      />
                      <img v-else
                        src="@/assets/images/pages/user-circle-solid.svg"
                        alt="user-img"
                        width="40"
                        height="40"
                        class="rounded-full shadow-md cursor-pointer block"
                      />
                      <div class="reply-block w-full ml-4">
                        <vs-textarea
                          class="mb-0"
                          v-model="replyData2.comments[index2]"
                          placeholder="Add a reply..."
                          @keyup.native.enter="
                            sendReply(fetchBlog.id, comment.id, index2)
                          "
                        />
                        <a class="sent-btn">
                          <feather-icon
                            @click="sendReply(fetchBlog.id, comment.id, index2)"
                            icon="SendIcon"
                          />
                        </a>
                      </div>
                    </div>
                    <!-- edit reply -->
                     <div
                    class="flex my-4"
                    v-if="
                      editReplyBoxShow === true &&
                      comment.id === trialData.parent_id
                    "
                  >
                  <img v-if="user.picture != null || user.picture != ''"
                        :src="user.picture"
                        alt="user-img"
                        width="40"
                        height="40"
                        class="rounded-full shadow-md cursor-pointer block"
                      />
                    <img v-else
                      src="@/assets/images/pages/user-circle-solid.svg"
                      alt="user-img"
                      width="40"
                      height="40"
                      class="rounded-full shadow-md cursor-pointer block"
                    />
                    <div class="reply-block w-full ml-4">
                      <vs-textarea
                        class="mb-0"
                        v-model="replyData2.comments[0]"
                        placeholder="Add a reply..."
                        @keyup.native.enter="editReply(index2)"
                      />

                      <a class="sent-btn">
                        <feather-icon
                          @click="editReply(index2)"
                          icon="SendIcon"
                        />
                      </a>
                    </div>
                  </div>
                  
                  </div>

                 
                </div>

                
              </div>
            </div>

            <!-- put your own comment section -->
            <div
              v-if="editCommentBoxShow === false"
              class="comment-section flex my-4"
            >
            <img v-if="user.picture != null || user.picture != ''"
                        :src="user.picture"
                        alt="user-img"
                        width="40"
                        height="40"
                        class="rounded-full shadow-md cursor-pointer block"
                      />
              <img v-else
                src="@/assets/images/pages/user-circle-solid.svg"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
              <div class="reply-block w-full ml-4">
                <vs-textarea
                  class="mb-0"
                  v-model="commentsData2.comments[index1]"
                  placeholder="Add a comment..."
                  @keyup.native.enter="sendComment(fetchBlog.id, index1)"
                />
                <a class="sent-btn">
                  <feather-icon
                    @click="sendComment(fetchBlog.id, index1)"
                    icon="SendIcon"
                  />
                </a>
              </div>
            </div>
            <div
              v-if="editCommentBoxShow === true && editBlogId === fetchBlog.id"
              class="comment-section flex my-4"
            >
            <img v-if="user.picture != null || user.picture != ''"
                        :src="user.picture"
                        alt="user-img"
                        width="40"
                        height="40"
                        class="rounded-full shadow-md cursor-pointer block"
                      />
              <img v-else
                src="@/assets/images/pages/user-circle-solid.svg"
                alt="user-img"
                width="40"
                height="40"
                class="rounded-full shadow-md cursor-pointer block"
              />
              <div class="reply-block w-full ml-4">
                <vs-textarea
                  class="mb-0"
                  v-model="commentsData.comments"
                  placeholder="Add a comment..."
                  @keyup.native.enter="editComment()"
                />
                <a class="sent-btn">
                  <feather-icon @click="editComment()" icon="SendIcon" />
                </a>
              </div>
            </div>
          </div>
          
        </vs-card>
      </span>
      </span>

      <vs-row vs-type="flex" vs-justify="space-between">
        <vs-col
          vs-type="flex"
          vs-lg="5"
          vs-sm="5"
          vs-xs="12"
        >
          <vs-button
            v-if="currentPage > 1"
            @click="showBack"
            color="primary"
            icon-pack="feather"
            icon="icon-arrow-left"
          ></vs-button>
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-lg="7"
          vs-sm="7"
          vs-xs="12"
        >
          <vs-button
            v-if="showButton == true && checkBlogViewPermission()"
            @click="showMore"
            >Load More</vs-button
          >
        </vs-col>
        <vs-divider />
      </vs-row>
    </div>

    <!-- share popup -->
    <vs-popup
      class="post-share-modal"
      title="Share"
      :active.sync="shareActive"
    >
      <span v-if="selectedUsersShow.length != 0">
        <h6 class="mb-2">Already Shared With :</h6>
        <div class="flex flex-wrap mb-4">
          <div
            class="text-center mr-1"
            v-for="(selectedUser, index14) in selectedUsersShow"
            :key="index14"
          >
            <div class="selected-names">
              <!-- <p>{{selectedUser.first_name[0]}} {{selectedUser.last_name[0]}}</p> -->
              <img v-if="selectedUser.picture!=null || selectedUser.picture!=''" class="person-img rounded-full shadow-md block" :src="selectedUser.picture" />
              <img v-else
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
            </div>
            <p class="name-selected">
              {{ selectedUser.first_name }} {{ selectedUser.last_name }}
            </p>
          </div>
        </div>
      </span>

      <span v-if="selectedClientsShow.length != 0">
        <div class="flex flex-wrap mb-4">
          <div
            class="text-center mr-1"
            v-for="(selectedUser, index15) in selectedClientsShow"
            :key="index15"
          >
            <div class="selected-names">
              <!-- <p>{{selectedUser.first_name[0]}}</p> -->
              <img v-if="selectedUser.picture!=null || selectedUser.picture!=''" class="person-img rounded-full shadow-md block" :src="selectedUser.picture" />
              <img v-else
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
            </div>
            <p class="name-selected">
              {{ selectedUser.first_name }} {{ selectedUser.last_name }}
            </p>
          </div>
        </div>
      </span>
      <span v-if="selectedUsers.length != 0">
        <h6 class="mb-2">Staffs</h6>
        <div class="flex flex-wrap mb-4">
          <div
            class="text-center mr-1"
            v-for="(selectedUser, index16) in selectedUsers"
            :key="index16"
          >
            <div class="selected-names">
              <!-- <p>{{selectedUser.first_name[0]}} {{selectedUser.last_name[0]}}</p> -->
              <img
                v-if="selectedUser.picture != '' || selectedUser.picture != null"
                class="person-img rounded-full shadow-md block"
                :src="selectedUser.picture"
              />
              <img
                v-else
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
              <span @click="closeSelectedUser(index16)" class="close"
                >&times;</span
              >
            </div>
            <p class="name-selected">
              {{ selectedUser.first_name }} {{ selectedUser.last_name }}
            </p>
          </div>
        </div>
      </span>
      <span v-if="selectedClients.length != 0">
        <h6 class="mb-2">Students</h6>
        <div class="flex flex-wrap mb-4">
          <div
            class="text-center mr-1"
            v-for="(selectedClient, index17) in selectedClients"
            :key="index17"
          >
            <div class="selected-names">
              <!-- <p>{{selectedClient.first_name[0]}} {{selectedClient.last_name[0]}}</p> -->
              <img
                v-if="selectedClient.picture != '' || selectedClient.picture != null"
                class="person-img rounded-full shadow-md block"
                :src="selectedClient.picture"
              />
              <img
                v-else
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
              <span @click="closeSelectedClient(index17)" class="close"
                >&times;</span
              >
            </div>
            <p class="name-selected">
              {{ selectedClient.first_name }} {{ selectedClient.last_name }}
            </p>
          </div>
        </div>
      </span>
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Staffs">
          <vs-table multiple v-model="selectedUsers" :data="userList">
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].picture">
                  <img
                    v-if="data[indextr].picture"
                    class="person-img rounded-full shadow-md block"
                    :src="data[indextr].picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full shadow-md block"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                </vs-td>
                <vs-td>
                  <span>
                    {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                  </span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="flex flex-wrap justify-between items-center my-4">
            <div>
              <vs-button
                v-if="currentPageUser > 1"
                @click="showBackUser"
                color="primary"
                icon-pack="feather"
                icon="icon-chevron-left"
              ></vs-button>
            </div>
            <div class="text-right">
              <vs-button
                icon-pack="feather"
                icon="icon-chevron-right"
                v-if="showButtonUser == true"
                @click="showMoreUser"
                ></vs-button
              >        
            </div> 
          </div>
          <div class="text-right mt-4">
            <vs-button @click="shareToUser">Share</vs-button>
          </div>
        </vs-tab>

        <vs-tab label="Students">
          <vs-table multiple v-model="selectedClients" :data="clientList">
            <template slot="thead">
              <vs-th>Select all</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].picture">
                  <img
                    v-if="data[indextr].picture"
                    class="person-img rounded-full shadow-md block"
                    :src="data[indextr].picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full shadow-md block"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                </vs-td>
                <vs-td>
                  <span
                    >{{ data[indextr].first_name }}
                    {{ data[indextr].last_name }}</span
                  >
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="flex flex-wrap justify-between items-center my-4">
            <div>
              <vs-button
                v-if="currentPageClient > 1"
                @click="showBackClient"
                color="primary"
                icon-pack="feather"
                icon="icon-chevron-left"
              ></vs-button>
            </div>
            <div class="text-right">
              <vs-button
                icon-pack="feather"
                icon="icon-chevron-right"
                v-if="showButtonClient == true"
                @click="showMoreClient"
                ></vs-button
              >
            </div>              
          </div>
          <div class="text-right mt-4">
            <vs-button @click="shareToUser">Share</vs-button>
          </div>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
    <!-- 2nd share modal  -->

    <vs-popup
      class="post-share-modal"
      title="Share"
      :active.sync="shareActive1"
    >
      <h6 class="mb-2" v-if="selectedUsers2.length != 0">Staffs</h6>
      <div class="flex flex-wrap mb-4">
        <div
          class="text-center mr-1"
          v-for="(selectedUser, index) in selectedUsers2"
          :key="index"
        >
          <div class="selected-names">
                  <img
                    v-if="selectedUser.picture != '' || selectedUser.picture != null"
                    class="person-img rounded-full shadow-md block"
                    :src="selectedUser.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full shadow-md block"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                
            <!-- <p>
              {{ selectedUser.first_name[0] }} {{ selectedUser.last_name[0] }}
            </p> -->
            <span @click="closeSelectedUser2(index)" class="close"
              >&times;</span
            >
          </div>
          <p class="name-selected">
            {{ selectedUser.first_name }} {{ selectedUser.last_name }}
          </p>
        </div>
      </div>

      <h6 class="mb-2" v-if="selectedClients2.length != 0">Students</h6>
      <div class="flex flex-wrap mb-4">
        <div
          class="text-center mr-1"
          v-for="(selectedClient, index) in selectedClients2"
          :key="index"
        >
          <div class="selected-names">
             <img
                    v-if="selectedClient.picture != '' || selectedClient.picture != null"
                    class="person-img rounded-full shadow-md block"
                    :src="selectedClient.picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full shadow-md block"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
            <!-- <p>
              {{ selectedClient.first_name[0] }}
              {{ selectedClient.last_name[0] }}
            </p> -->
            <span @click="closeSelectedClient2(index)" class="close"
              >&times;</span
            >
          </div>
          <p class="name-selected">
            {{ selectedClient.first_name }} {{ selectedClient.last_name }}
          </p>
        </div>
      </div>
      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Staffs">
          <vs-table multiple v-model="selectedUsers2" :data="userListForAdd">
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].picture">
                  <img
                    v-if="data[indextr].picture"
                    class="person-img rounded-full shadow-md block"
                    :src="data[indextr].picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full shadow-md block"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                </vs-td>
                <vs-td>
                  {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="flex flex-wrap justify-between items-center my-4">
            <div>
              <vs-button
                v-if="currentPageUser > 1"
                @click="showBackUser"
                color="primary"
                icon-pack="feather"
                icon="icon-chevron-left"
              ></vs-button>
            </div>
            <div class="text-right">
              <vs-button
                type="flat"
                icon-pack="feather"
                icon="icon-chevrom-right"
                v-if="showButtonUser == true"
                @click="showMoreUser"
                ></vs-button
              >
            </div>            
          </div>
          <div class="text-right mt-4">
            <vs-button @click="submit(true)">Share</vs-button>
          </div>
        </vs-tab>

        <vs-tab label="Students">
          <vs-table
            multiple
            v-model="selectedClients2"
            :data="clientListForAdd"
          >
            <template slot="thead">
              <vs-th>Select all</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].picture">
                  <img
                    v-if="data[indextr].picture"
                    class="person-img rounded-full shadow-md block"
                    :src="data[indextr].picture"
                  />
                  <img
                    v-else
                    class="person-img rounded-full shadow-md block"
                    src="@/assets/images/pages/user-circle-solid.svg"
                  />
                </vs-td>
                <vs-td>
                  {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <div class="flex flex-wrap justify-between items-center my-4">
            <div>
              <vs-button
                v-if="currentPageClient > 1"
                @click="showBackClient"
                color="primary"
                icon-pack="feather"
                icon="icon-chevron-left"
              ></vs-button>
            </div>
            <div class="text-right">
              <vs-button
                icon-pack="feather"
                icon="icon-chevron-right"
                v-if="showButtonClient == true"
                @click="showMoreClient"
                ></vs-button
              >
            </div>
          </div>
          <div class="text-right mt-4">
            <vs-button @click="submit(true)">Share</vs-button>
          </div>
        </vs-tab>
      </vs-tabs>
    </vs-popup>

    <!-- edit modal -->
    <!-- <vs-popup
      class="post-edit-modal"
      title="Edit Post"
      :active.sync="modalEditActive"
    > -->
    <div class="vs-component con-vs-popup vs-popup-primary cstm-modal-popup vs-con-loading__container post-edit-modal" v-if="modalEditActive" :class="{show: modalEditActive}">
      <div class="cstm-modal">
        <div class="header">
            <h4>Edit Post</h4>
            <button @click="closeEditModal" class="close-modal">&times;</button>
        </div>
        <div class="modal-content p-4">
          <div class="flex">
            <img
              v-if="user.picture != null || user.picture != ''"
              :src="user.picture"
              alt="user-img"
              width="40"
              height="40"
              class="rounded-full shadow-md cursor-pointer block"
            />
            <img
              v-else
              src="@/assets/images/pages/user-circle-solid.svg"
              alt="user-img"
              width="40"
              height="40"
              class="rounded-full shadow-md cursor-pointer block"
            />
            <div class="ml-4">
              <h5>{{ customerName }} <span v-if="user.last_name!=null">{{user.last_name}}</span></h5>
              <div class="info_block">
                <p v-if="customerType == 1">Admin</p>
                <p v-if="customerType == 0">Staff</p>
              </div>
            </div>
          </div>
          <vs-textarea class="mt-5" v-model="blogData.title" placeholder="Title" />
          <editor
            v-model="blogData.blog"
              :api-key="tinyMceApi"
              :init="initializeTinyMce"
          />
          <div class="text-right mt-4">
            <vs-button :disabled="showPostButton" @click="blogUpdate">Update</vs-button>
          </div>
        </div>
      </div>
    </div>

    <vs-popup title="Delete Post" :active.sync="deletepopupflag">
      <vs-row>
        <span>Are you sure to delete this post?</span>
      </vs-row>
      <vs-row vs-type="flex" vs-justify="flex-end" class="mt-4">
        <vs-button
          @click="deleteBlog"
          color="primary"
          type="filled"
          class="mr-2 vs-con-loading__container"
          >Confirm</vs-button
        >
        <vs-button @click="deletepopupflag = !deletepopupflag" type="border"
          >Cancel</vs-button
        >
      </vs-row>
    </vs-popup>
    <div v-if="isBrowseContent">
      <vs-popup fullscreen title="Browse Item" :active.sync="isBrowseContent" class="childImportPopUp browse_modal_item">
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="repository_id"
          @getImportFile="getImportFile"
          :multipleSelect="true"
        ></import-browse-files-model>
        <div slot="footer"></div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import Editor from '@tinymce/tinymce-vue'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
import {GoogleAuthorization} from '@/mixins/common/GoogleAuthorization.js'
import { blog } from './mixins/blog.js'
import {repository} from '@/mixins/repository.js'
import {
  emoticonsList
} from '@/api/blog-post.js'
export default {
  name: 'Blogs-Post',
  mixins: [blog, PermissionMiddleware, GoogleAuthorization, repository],
  components: {
    editor: Editor,
    ImportBrowseFilesModel
  },
  async created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false
      this.getModulePermission('Communication', 'blog')
    }
    this.tinyMceApi = process.env.VUE_APP_TINYMCE_API
    const customer_id = localStorage.getItem('customer_id')
    const imageUploadUrl = process.env.VUE_APP_IMAGE_UPLOAD_URL
    this.image_url = `${imageUploadUrl}${customer_id}`
    await this.getRepositoryId(this.COMMUNICATIONS_MODULE_ID)
    this.file_repository_id = this.repository_id
  },
  computed: {
    showPostButton () {
      if (this.blogData.title === '' || this.blogData.blog === '') {
        return true
      } else {
        return false
      }
    }
  },
  mounted () {
    this.query_page.search = this.searchData
    this.blogListFetch()
    this.fetchUser()
    this.fetchClient()
    emoticonsList()
      .then((res) => {
        
        this.emoticonsList = res.data.data.emoticons
      })
      .catch((e) => {
        
      })
    this.user = JSON.parse(localStorage.getItem('userInfo'))
    this.customerName = this.user.first_name
    this.userPicture = this.user.picture
  }
  
}
</script>

<style>
.width-66 {
  width: 66.67%;
}
.border-top {
  border-top: 4px solid rgba(var(--vs-primary), 1);
}
.blog-image-holder {
  width: 100%;
  height: 300px;
}
.blog-image-holder img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.divider {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.feedback-block {
  background: #eff3f4;
  border-radius: 8px;
  padding: 10px;
  position: relative;
}
.commented-section .feedback-block {
  max-width: 65%;
}
.commented-emoji {
  display: flex;
  position: absolute;
  right: -20px;
  bottom: 0;
}
.commented-emoji img {
  width: 18px;
}
.replied-section,
.reply-para {
  margin-left: 50px;
}
.reply-block {
  position: relative;
}
.sent-btn {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  height: 100%;
  padding: 0 15px;
  cursor: pointer;
}
.reply-block::after {
  content: "";
  width: 1px;
  height: 50%;
  background: rgba(0, 0, 0, 0.1);
  position: absolute;
  right: 54px;
  top: 50%;
  transform: translateY(-50%);
}
.reply-block .vs-textarea {
  height: 65px;
  padding-right: 60px;
}
.post-block .info_block {
  display: flex;
  align-items: center;
}
.post-block .info_block p {
  display: flex;
  align-items: center;
}
.post-block .info_block p:not(:last-child)::after {
  content: "";
  width: 2px;
  height: 15px;
  background: rgba(0, 0, 0, 0.2);
  display: inline-flex;
  margin: 0 10px;
}
.like-section {
  display: flex;
  justify-content: flex-end;
}
.like-section img,
.emoji-section img {
  width: 20px;
}
.post-share-modal table .person-img {
  width: 20px;
}
.post-share-modal .vs-table--thead {
  display: none;
}
.post-share-modal table tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.post-share-modal table td:first-child,
.post-share-modal table td:nth-child(2) {
  width: 10px;
}
.like-reaction {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  z-index: 10;
  overflow: hidden;
}
.like-reaction img,
.like-reaction img.emoji {
  width: 24px;
}
.like-reaction:hover {
  overflow: unset;
}
.like-reaction:hover .emoji-section {
  transform: translateY(-70%);
  opacity: 1;
}
.emoji-section {
  display: flex;
  background: #fff;
  position: absolute;
  left: 0;
  border-radius: 30px;
  padding: 10px;
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.2);
  transform: translateY(-40%);
  opacity: 0;
  z-index: 1;
  transition: transform 0.5s ease;
}
.emoji-section img {
  margin: 2px;
}
.post-edit-modal.con-vs-popup .vs-popup {
  width: 60%;
}
.tox-tinymce-aux {
  z-index: 10000000000 !important;
}
.selected-names {
  background: #e5e4e8;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-right: 5px;
  color: #0078d4;
  font-weight: 600;
  position: relative;
}
.selected-names img {
  width: 100%;
}
.selected-names .close {
  color: white;
  position: absolute;
  top: -8px;
  right: -7px;
  font-size: 25px;
  cursor: pointer;
  background: #0078d4;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.name-selected {
  white-space: nowrap;
  width: 75px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.blog-content img {
  width: 100%;
  object-fit: contain;
}
.blog-content iframe {
  height: 300px;
}
.emoticons-holder {
  position: relative;
  margin-left: -10px;
}
.emoticons-holder .emoticons-list {
  position: absolute;
  left: 0;
  top: 100%;
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 10px;
  border-radius: 8px;
  z-index: 100;
  display: none;
}
.emoticons-holder:hover .emoticons-list {
  display: block;
}
@media (max-width: 991px) {
  .width-sm-100 {
    width: 100%;
  }
}
</style>